"use client";

import { useSession } from "next-auth/react";

import ImpersonationBanner from "./ImpersonationBanner";

/**
 * NextAuth-backed read-only impersonation banner for the exams and open apps.
 * Reads `impersonatedBy` from the session (threaded through in the NextAuth
 * config) and renders the shared banner. The teacher dashboard is Firebase-only
 * and sources the same signal from the ID token claims instead.
 */
export default function NextAuthImpersonationBanner() {
  const { data: session } = useSession();
  return (
    <ImpersonationBanner
      impersonatedBy={session?.impersonatedBy}
      viewingAs={session?.user?.email}
      writable={session?.impersonationWritable}
    />
  );
}
